<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-6"
      v-model="form.stdInfo"
      :board="this.board"
      :date-readonly="false"
      :is-print="isPrint" />


    <!-- 안전보건 협의체 구성 현황 -->
    <item-list-editor
      title="안전보건 협의체 구성 현황"
      list-type="default"
      checked-key="isChecked"
      v-model="form.councilList"
      @click="onClickCouncilList"
    >
      <template slot-scope="{ data }">
        <table class="w-full mb-4">
          <tr>
            <th rowspan="4">
              <div class="flex justify-center">
                <vs-checkbox class="m-0 p-0" v-model="data.isChecked"/>
              </div>
            </th>
            <th>대상사업</th>
            <th>사업명(작업명)</th>
            <td><ml-input class="w-full" v-model="data.대상사업.사업명"/></td>
            <th>작업기간</th>
            <td><date-selector-rang v-model="data.대상사업.작업기간" style="display: grid; grid-template-columns: 1fr 28px 1fr; align-items: center; text-align: center;"/></td>
          </tr>

          <tr>
            <th rowspan="3">수급업체</th>
            <th>회사명</th>
            <td><ml-input class="w-full" v-model="data.수급업체.회사.name"/></td>
            <th>TEL)</th>
            <td><ml-input class="w-full" type="tel" v-model="data.수급업체.회사.tel"/></td>
          </tr>

          <tr>
            <th>대표자</th>
            <td><ml-input class="w-full" v-model="data.수급업체.대표자.name"/></td>
            <th>H.P.)</th>
            <td><ml-input class="w-full" type="tel" v-model="data.수급업체.대표자.hp"/></td>
          </tr>

          <tr>
            <th>담당자</th>
            <td>
              <div class="w-full" style="display: grid; grid-template-columns: auto 1fr auto 1fr; align-items: center; gap: 1rem;">
                <span>직)</span> <ml-input class="w-full" v-model="data.수급업체.담당자.rank"/>
                <span>성명)</span> <ml-input class="w-full" v-model="data.수급업체.담당자.name"/>
              </div>
            </td>
            <th>H.P.)</th>
            <td><ml-input class="w-full" type="tel" v-model="data.수급업체.담당자.hp"/></td>
          </tr>

        </table>
      </template>

      <template slot="foot">
        <div class="pt-4">
          <p class="p-4 text-center font-medium" style="background-color: #F9F9F9; border: 1px solid #cdcdcd;">운영 사항(공통)</p>
          <ul class="p-4 list-style-dot" style="border: 1px solid #cdcdcd; border-top: none;">
            <li>매월 1회 이상 정기회의 개최(대면 또는 비대면 개최)</li>
            <li>학교 자체 작업장 순회점검(주 1회)</li>
            <li>작업장에 대한 안전·보건 합동점검(반기 1회)</li>
          </ul>
        </div>
      </template>
    </item-list-editor>

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-28px" :is-print="isPrint" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import ItemListEditor from "@/components/ListEditor/ItemListEditor.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  components: {
    DateSelectorRang,
    ItemListEditor,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        councilList: [],
      },
    };
  },
  created() {
    // 한개의 항목은 기본으로 생성
    this.addCouncilList();
  },
  methods: {
    onSelectFieldSelector (value) {
      this.form.학교명 = value.field_name;
    },
    addCouncilList () {
      this.form.councilList.push({
        "isChecked": false, // 체크박스 체크 여부
        "대상사업": {
          "사업명": "", // 대상사업명
          "작업기간": {
            "sDate": "",
            "eDate": "",
          },
        },
        "수급업체": {
          "회사": {
            "name": "",
            "tel": "",
          },
          "대표자": {
            "name": "",
            "hp": "",
          },
          "담당자": {
            "rank": "",
            "name": "",
            "tel": "",
          },
        }
      });
    },

    onClickCouncilList (key, value) {
      if (key === 'add') {
        this.addCouncilList();
      } else if (key === 'delete') {

      }
      console.log("key:", key, ", value:", value)
    }
  },
};
</script>

<style scoped lang="scss">
.list-style-dot li {
  &::before {
    content: "•";
    color: #000;
    display: inline-block;
    width: 1em;
    margin-left: 0em;
  }
}

table {
  border-spacing: 0;
  border-collapse: collapse;

  th, td {
    padding: 0.5rem;
    border: 1px solid #cdcdcd;
  }
  th {
    text-align: center;
    background-color: #f9f9f9;
  }
}
</style>
